import { apiClient } from '@/lib/api.ts'

export function getAiModels() {
  return apiClient.get<Record<string, { id: string; name: string }[]>>('/ai/models')
}
